<template>
    <div :style="styleWrapper">
        <div :class="classesWrapper" class="w-full h-1.5 ">
            <div class="h-1.5 rounded-full transition-all duration-300" :class="classesBar" :style="styleBar"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        debug: { type: Boolean },
        current: { type: Object, required: true },
        funnel: { type: Object, required: true },
        steps: { type: Array, required: true },
    },
    computed: {
        classesWrapper() {
            return `bg-gray-200 dark:bg-gray-700`
        },
        classesBar() {
            return `bg-${this.primaryColor}-600 dark:bg-${this.primaryColor}-500`
        },
        primaryColor() {
            return this.funnel.settings && this.funnel.settings.primary ? this.funnel.settings.primary : 'indigo'
        },
        styleBar() {
            let currentIndex = this.current.index
            let nSteps = this.funnel.steps_questionnaire_count ? this.funnel.steps_questionnaire_count : this.steps.length
            let percentage = nSteps > 0 ? Math.round(currentIndex/nSteps*100) : 100;
            return { width: percentage+'%' }
        },
        styleWrapper() {
            return {
                position: "fixed",
                bottom: 0, left: 0, right: 0
            }
        }
    }
}
</script>

<style>

</style>
